import { gql } from '@apollo/client';

export const GET_PROFILE = gql`
  query profile {
    getMyProfile {
      recommendedPaths {
          score
          path {
              _id
          }
      }
      nbSessionsDone
      visitedPages
      nbSessionsDone
      MHCNextDate
      matchingSurveyDone
      redoSessionDone
      registeredWithWpo
      wpoRegion
      activePath{
        _id
      }
      recommendedPages {
        recommendationStrategy {
          _id
        }
        feature {
          _id
        }
      }
      company {
        _id
        withRedoSession
        companyRegions {
          region
          language
        }
        hasAccessToEvolunoAssistance
        hasAccessToOwnAssistance
        hasAccessToWpoAssistance
        hasAccessToScheduler
        hasAccessToFaceScan
        assistanceInfo
        logo
        ownAssistanceTitle
        ownAssistanceText
        ownAssistanceButtonText
        ownAssistanceColor
        explanationConditioning
        pricingQuestion
        ownAssistanceItems {
          _id
          type
          image
          title
          description
          linkInfo
        }
      }
    }
  }
`;

export const GET_RECKONING_RESULT = gql`
  query profile {
    getMyProfile {  
      recommendedPages {
        recommendationStrategy {
          _id
        }
        feature {
          _id
        }
      }
    }
  }
`;


export const GET_ONE_SIGNAL_TAGS = gql`
  query fetchOneSignalTags {
    fetchOneSignalTags {
      number_of_path_started
      number_of_path_completed
    }
  }
`;

export const GET_NB_SESSIONS_DONE = gql`
  query profile {
    getMyProfile {
      nbSessionsDone
    }
  }
`;

export const FETCH_RECOMMENDED_PATHS = gql`
  query profile {
    getMyProfile {
      recommendedPaths {
          score
          path {
              _id
          }
      }
    }
  }
`;

export const FETCH_OWN_ASSISTANCE_ITEMS = gql`
  query profile {
    getMyProfile {
      company {
        _id
        ownAssistanceItems {
          _id
          type
          image
          title
          description
          linkInfo
        }
      }
    }
  }
`;

export const GET_REDIRECTION = gql`
  query profile {
    getMyProfile {
      registerRedirection {
        type
        reckoning{
          _id
          onboardingDoneWhenThisReckoningIsDone
          session {
            _id
          }
        }
        session {
          _id
        }
      }
    }
  }
`;

export const GET_NOTIFICATION = gql`
  query getMyProfile {
    getMyProfile {
      _id
      evolutime {
        active
        daysOfWeek
        hour
        minute
      }
    }
  }
`;


export const GET_PSYCHOLOGISTS = gql`
  query getPsychologists{
    getMyProfile {
      psychologists {
        _id
        firstName
        lastName
        profileImage
        psychoTitle
        psychoDescription
        psychoLocation
        psychoTimetable
      }
      contacts {
        _id
        firstName
        lastName
        profileImage
        psychoTitle
        psychoDescription
        psychoLocation
        psychoTimetable
      }
      matching {
        _id
        dateUpdated
        isFound
        isManualMatchingSearchActive
        value {
          isManual
          score
          ranking
          psychologist
          criteria {
            criteria
            score
            status
            label
            results {
              label
              matched
            }
            altResult
            shouldDisplayLabel
            shouldDisplayResults
            shouldDisplayAltResult
          }
        }
      }
    }
  }
`;
export const CUSTOM_SESSION = gql`
query customSession($message: String!) {
  customSession(message: $message)  {
    _id
    title
    shortDescription
    order
    sessionType
    dateCreated
    steps {
      _id
      order
      contentType
      text
      content{
        _id
      }
      exercise {
        _id
      }
      survey{
        _id
      }
	}
  }
}
`;
export const GET_WPO_APPOINTMENTS = gql`
  query getWpoAppointments {
    getWpoAppointments {
      upcomingAppointments {
        appointmentId
        companyId
        dateFrom
        counsellorName
        status
        timeZoneCode
        appointmentModeLabel
      }
    }
  }
`;


